import { createAction } from '@reduxjs/toolkit';

export const startSubscriptionsPageRequest = createAction('subscriptions/startSubscriptionsPageRequest');
